import React from 'react';
import { capitalize } from '@dagensmat/core';
import { Container } from '@dagensmat/carrot/Layout';
import { Typography } from '@dagensmat/carrot/Components';
import { formatDate } from 'utils/date/format';
import ProductBuyer from '_common/components/product-buyer/ProductBuyer';
import { updateSelectedDeliveryDate } from '_consumer/reducers/productsForSale';
import {
  calculateMinimumOrderThreshold,
  updateBasket
} from '_consumer/reducers/basket';
import {
  DeliveryDateContext,
  chooseDeliveryDateFromContext,
  DELIVERY_DATE_CONTEXT_DEFAULT
} from '_common/context/DeliveryDateContext';
import { track, SELECT_DELIVERY_DAY_PRODUCT } from 'utils/mixpanel';
import { useAppDispatch, useAppSelector } from '_common/hooks/reduxHooks';
import { ProductForSale } from 'types/Product';
import { DeliveryDate } from '_common/components/search/DeliveryDateOptions';
import ProductDeliveryDateSelection from './ProductDeliveryDateSelection';

type ModalBuyerWrapperProps = {
  product: ProductForSale;
};

const ModalBuyerWrapper = ({ product }: ModalBuyerWrapperProps) => {
  const { selectedDeliveryDate, availableDeliveryDates } = useAppSelector(
    ({ productsForSale }) => {
      return {
        selectedDeliveryDate: productsForSale.selectedDeliveryDate,
        availableDeliveryDates: productsForSale.availableDeliveryDates
      };
    }
  );
  const dispatch = useAppDispatch();

  const context = React.useContext(DeliveryDateContext);

  const { pageContext, setIsolatedContextDeliveryDate } = context;

  const { _id: productId, hasSpecialPricing } = product;

  const deliveryDate = chooseDeliveryDateFromContext(
    context,
    selectedDeliveryDate
  );

  const setDeliveryDate = (date: DeliveryDate) => {
    dispatch(
      updateBasket({
        deliveryDate: date,
        productId,
        units: 1,
        hasSpecialPricing
      })
    );
    dispatch(calculateMinimumOrderThreshold());

    if (pageContext === DELIVERY_DATE_CONTEXT_DEFAULT) {
      dispatch(updateSelectedDeliveryDate(date));
    } else {
      setIsolatedContextDeliveryDate?.(date);
    }
    track(SELECT_DELIVERY_DAY_PRODUCT);
  };

  return (
    <Container my="m">
      {deliveryDate ? (
        <>
          <Typography variant="inputLabel">
            Ordering for {capitalize(formatDate(deliveryDate, 'iii d. MMM'))}
          </Typography>
          <ProductBuyer product={product} selectedDeliveryDate={deliveryDate} />
        </>
      ) : (
        <ProductDeliveryDateSelection
          product={product}
          availableDeliveryDates={availableDeliveryDates}
          setDeliveryDate={setDeliveryDate}
        />
      )}
    </Container>
  );
};

export default ModalBuyerWrapper;
